import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';

const theme = createTheme({
  typography: {
    fontFamily: '"Space Grotesk", sans-serif',
  },
  palette: {
    primary: {
      main: '#ff7c38',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2e3649',
      contrastText: '#ffffff',
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: { color: 'secondary' },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          '&:hover': { backgroundColor: '#e56820' },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: { backgroundColor: '#ff7c38', color: '#fff' },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);